import { IDB } from '@/core/db'

export function parseProfileData(column?: string, dbClient?: IDB, userEmail?: string) {
  if (!column || !dbClient) return

  // get app user table id (window)
  const appUserTableID = window.appUserTableID

  // find user table
  const userTable = dbClient.tablesMap.get(appUserTableID)
  if (!userTable) return

  // check if column exist in user table
  const foundColumn = userTable.columnsMap.get(column)
  if (!foundColumn) return

  // find email column
  const emailColumn = userTable.GetUserTableColumnAttributes()?.email
  if (!emailColumn) return

  const rows = userTable.GetTableUsers()
  if (!rows) return

  const userRowData = rows.find((row) => {
    return row[emailColumn._id].toString() === userEmail
  })

  if (!userRowData) return

  return userRowData[column].toString()
}
